import React, { useEffect } from 'react';
import './index.scss';

import {
  BsFillTelephoneFill, BsEnvelopeFill, BsFillReplyFill, BsClockFill
} from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Carousel } from 'react-carousel-minimal';
import { DOCTORS, TURNS_PATH } from '../../routes/path';
import { getInfo } from '../../redux/actions/infoGeneralActions';
import { Loading, Map, Toast } from '../../components';

const InformationScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, isLoadingInfo, infoGeneral } = useSelector((state) => state.infoReducer);
  useEffect(() => {
    dispatch(getInfo());
  }, []);

  const renderIconText = (icon, text) => {
    let render = text;
    if (typeof text === 'object') {
      render = (
        <div className="text-renderIcon">
          <ul>
            {text?.map((item) => (
              <li><span key={item}>{item}</span></li>
            ))}
          </ul>
        </div>
      );
    }
    return (
      <div className="container-icon-text">
        <span>
          <span className="icon-border">
            {icon}
          </span>
          {render}
        </span>
      </div>
    );
  };
  if (isLoadingInfo) return <Loading />;

  const redirect = () => {
    navigate(`${TURNS_PATH}${DOCTORS}`);
  };

  const textRender = [{
    icon: <BsFillReplyFill className="icon iconEspejado" />,
    text: infoGeneral?.direccion
  },
  {
    icon: <BsFillTelephoneFill className="icon" />,
    text: infoGeneral?.telefonos
  }, {
    icon: <BsEnvelopeFill className="icon" />,
    text: infoGeneral?.emails
  }, {
    icon: <BsClockFill className="icon" />,
    text: infoGeneral?.horarios_atencion
  }];

  return (
    <div className="container-info">
      <Toast error={error} />
      {infoGeneral?.fotos.length > 0 && (
        <div className="carrusel">
          <Carousel
            data={infoGeneral?.fotos?.map((foto) => ({ image: `${process.env.REACT_APP_BACKEND_URL}${foto}` }))}
            time={2000}
            width="100%"
            height="550px"
            captionPosition="bottom"
            automatic
            dots
            pauseIconColor="white"
            pauseIconSize="40px"
            slideBackgroundColor="darkgrey"
            slideImageFit="cover"
            thumbnailWidth="100px"
            style={{
              width: '100%',
              textAlign: 'center',
              margin: '-15px 0 70px 0',
              maxHeight: '600px'
            }}
          />
        </div>
      )}

      <div className="row-info border-bottom">
        <h2 className="title-info-first">Centro de Especialidades Oftalmológicas</h2>
        <button onClick={redirect} className="button-turn-info">Reservar turno</button>
      </div>
      <div className="container-infoMap">
        <div className="row-info1">
          <div>
            <div className="column-info border-bottom">
              <h2 className="title-info">Datos útiles</h2>
              {textRender.map((item) => (
                <div className="map-text" key={item.text}>
                  {renderIconText(item.icon, item.text)}
                </div>
              ))}
            </div>
            <div className="descripcion">
              <h4>Información</h4>
              {infoGeneral?.descripcion}
            </div>
          </div>
        </div>
        <div className="info-map">
          <h2>Ubicación y estacionamientos cercanos</h2>
          <Map location={infoGeneral} />
        </div>
      </div>
    </div>
  );
};

export default InformationScreen;
